<nav class="unav">
  <a class="nav-logo" href="pc_home.html">
    <img src="assets/img/logo.png" alt="Police Officers Connect Logo">
    <div><div class="nav-brand-name">Police Officers Connect</div><div class="nav-brand-sub">UMYO Network</div></div>
  </a>
  <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
  <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
    <li><a routerLink="/" class="active">Home</a></li>
    <li><a routerLink="/about">About</a></li>
    <li><a routerLink="/support">Officer Support</a></li>
    <li><a routerLink="/business">For Business</a></li>
    <li><a routerLink="/services">Type Of Services</a></li>
    <li><a routerLink="/cf">Card Features</a></li>
  </ul>
  <a href="#header" class="nav-cta">Join Now</a>
</nav>

<div class="page-hero">
  <div class="hero-grid"></div>
  <div class="hero-scan"></div>
  <div style="position:relative;z-index:1;max-width:900px;margin:0 auto;">
    <div class="hero-badge">&#9733; UMYO Network &middot; Nationwide Law Enforcement Platform &#9733;</div>
    <h1 class="hero-title">Police Officers<br><em>Connect</em></h1>
    <span class="gold-bar"></span>
    <p class="hero-sub">Elevating Networking for Law Enforcement Nationwide &mdash; A groundbreaking solution designed exclusively for law enforcement professionals.</p>
    <a href="/"  class="hero-url">🌐 www.umyopd.site</a>
    <div style="margin-top:32px;display:flex;gap:14px;justify-content:center;flex-wrap:wrap;animation:fadeUp 1s .5s ease both;">
      <a href="/#header" style="font-family:Oswald,sans-serif;font-size:12px;font-weight:700;letter-spacing:2px;text-transform:uppercase;padding:14px 34px;background:var(--gold);color:var(--black);text-decoration:none;clip-path:polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%);transition:all .3s;">Join the Movement</a>
      <a href="/about" style="font-family:Oswald,sans-serif;font-size:12px;font-weight:700;letter-spacing:2px;text-transform:uppercase;padding:14px 34px;border:1px solid rgba(201,151,58,0.5);color:var(--gold);text-decoration:none;transition:all .3s;">Learn More</a>
    </div>
  </div>
</div>

<div class="page-body">

  <!-- HOW IT WORKS -->
  <section class="section navy" style="padding:50px 24px 60px;">
    <div class="container">
      <div class="sec-head" data-aos="fade-up">
        <span class="sec-badge">How It Works</span>
        <h2 class="sec-title">Four Steps to <em>Impact</em></h2>
      </div>
      <div class="steps-row">
        <div class="step" data-aos="fade-up" data-aos-delay="0"><div class="step-num">01</div><span class="step-icon">👤</span><div class="step-title">Officers Join</div><p class="step-sub">Create a profile, upload records, achievements, and media.</p></div>
        <div class="step-arr">&#8594;</div>
        <div class="step" data-aos="fade-up" data-aos-delay="80"><div class="step-num">02</div><span class="step-icon">🏭</span><div class="step-title">Businesses Connect</div><p class="step-sub">Register and link to officers using unique ID codes.</p></div>
        <div class="step-arr">&#8594;</div>
        <div class="step" data-aos="fade-up" data-aos-delay="160"><div class="step-num">03</div><span class="step-icon">👥</span><div class="step-title">Engage &amp; Participate</div><p class="step-sub">Network, access resources, and receive recognition.</p></div>
        <div class="step-arr">&#8594;</div>
        <div class="step" data-aos="fade-up" data-aos-delay="240"><div class="step-num">04</div><span class="step-icon">✨</span><div class="step-title">Community Impact</div><p class="step-sub">Officers and families benefit from support, giveaways, and LMS programs.</p></div>
      </div>
    </div>
  </section>

  <!-- LAUNCH BANNER -->
  <section class="section dark">
    <div class="container">
      <div class="sec-head" data-aos="fade-up">
        <span class="sec-badge">National Launch</span>
        <h2 class="sec-title">National Private Police Officers <em>Network Launches</em></h2>
        <p class="sec-sub">A new nationwide initiative officially launching to strengthen financial stability, community connection, and economic support for police officers, security personnel, and their families.</p>
      </div>

      <!-- Flyer Image -->
      <div class="flyer-wrap" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="100">
        <img src="assets/img/flyer.png" alt="National Private Police Officers Network Launch Flyer">
      </div>

      <!-- Stats -->
      <div class="stats-band" data-aos="fade-up" data-aos-duration="900" data-aos-delay="150">
        <div class="stat"><span class="stat-num">$9<span style="font-size:22px">.99</span></span><div class="stat-lbl">Officers &amp; The Blue<br>Per Month</div></div>
        <div class="stat"><span class="stat-num">$2<span style="font-size:22px">.54</span></span><div class="stat-lbl">Supporters &amp; Families<br>Per Month</div></div>
        <div class="stat"><span class="stat-num">$49<span style="font-size:22px">.99</span></span><div class="stat-lbl">Businesses Supporting<br>The Blue</div></div>
      </div>
    </div>
  </section>

  <!-- WHO WE SERVE -->
  <section class="section navy">
    <div class="container">
      <div class="sec-head" data-aos="fade-up"><span class="sec-badge">Who We Serve</span><h2 class="sec-title">Built for Law <em>Enforcement</em></h2></div>
      <div class="serve-tags">
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="0"><span>👮</span>Police Officers</div>
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="50"><span>⭐</span>Veterans</div>
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="100"><span>📅</span>Recruiters</div>
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="150"><span>🏫</span>Instructors</div>
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="200"><span>🏛</span>Police Institutions</div>
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="250"><span>🏭</span>Supporting Businesses</div>
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="300"><span>👪</span>Officer Families</div>
        <div class="serve-tag" data-aos="zoom-in" data-aos-delay="350"><span>👥</span>Security Personnel</div>
      </div>
    </div>
  </section>

  <!-- WHY JOIN -->
  <section class="section dark">
    <div class="container">
      <div class="sec-head" data-aos="fade-up"><span class="sec-badge">Why Join</span><h2 class="sec-title">Built for Officers. <em>Powered by Community.</em></h2></div>
      <div class="grid-3">
        <div class="benefit-card" data-aos="fade-right" data-aos-delay="0"><div class="benefit-icon">🔒</div><div class="benefit-text"><h4>Secure &amp; Exclusive</h4><p>Only verified law enforcement professionals gain access. A safe, dedicated environment designed just for them.</p></div></div>
        <div class="benefit-card" data-aos="fade-up" data-aos-delay="80"><div class="benefit-icon">🌐</div><div class="benefit-text"><h4>Nationwide Reach</h4><p>Connect with officers, institutions, and businesses across the entire United States.</p></div></div>
        <div class="benefit-card" data-aos="fade-left" data-aos-delay="160"><div class="benefit-icon">📈</div><div class="benefit-text"><h4>Career Advancement</h4><p>Tools, training, and visibility to help you grow professionally within law enforcement.</p></div></div>
        <div class="benefit-card" data-aos="fade-right" data-aos-delay="0"><div class="benefit-icon">👪</div><div class="benefit-text"><h4>Family &amp; Community Support</h4><p>Programs and initiatives to help officers and their loved ones during hardship.</p></div></div>
        <div class="benefit-card" data-aos="fade-up" data-aos-delay="80"><div class="benefit-icon">🏆</div><div class="benefit-text"><h4>Recognition &amp; Networking</h4><p>A platform to celebrate achievements and build lasting connections nationwide.</p></div></div>
        <div class="benefit-card" data-aos="fade-left" data-aos-delay="160"><div class="benefit-icon">📚</div><div class="benefit-text"><h4>Learning &amp; Development</h4><p>Free online courses via LMS to advance your career and professional growth.</p></div></div>
      </div>
    </div>
  </section>

    <!-- PRICING -->
  <section class="section ">
    <div class="container">
      <div class="sec-head" data-aos="fade-up"><span class="sec-badge">Membership Tiers</span><h2 class="sec-title">Choose Your <em>Membership</em></h2></div>
      <div class="pricing-row" data-aos="fade-up" data-aos-duration="900" data-aos-delay="100">
        <div class="price-tile featured">
          <div class="price-who">Officers &amp; The Blue</div>
          <div class="price-name">Officer Membership</div>
          <div class="price-amt">$9<span style="font-size:26px">.99</span></div>
          <div class="price-per">PER MONTH</div>
          <div class="price-desc">Full platform access, career visibility, networking, LMS courses, recognition programs, and eligibility for officer &amp; family relief fund.</div>
          <a href="#header" class="price-btn gold">Join as Officer</a>
        </div>
        <div class="price-tile">
          <div class="price-who">Supporters &amp; Families</div>
          <div class="price-name">Family Member</div>
          <div class="price-amt">$2<span style="font-size:26px">.54</span></div>
          <div class="price-per">PER MONTH</div>
          <div class="price-desc">Support your officer, access community programs, eligibility for family assistance, daily giveaways, and LMS educational resources.</div>
          <a href="#header" class="price-btn outline">Join as Family</a>
        </div>
        <div class="price-tile">
          <div class="price-who">Business Registration</div>
          <div class="price-name">Businesses Supporting The Blue</div>
          <div class="price-amt">$49<span style="font-size:26px">.99</span></div>
          <div class="price-per">NATIONWIDE STARTING RATE</div>
          <div class="price-desc">Connect with verified officers, promote your business to law enforcement, contribute to officer programs, and gain nationwide visibility.</div>
          <a href="#header" class="price-btn gold">Register Business</a>
        </div>
      </div>
    </div>
  </section>

  <!-- FORM -->
  <section id="header" >
    <div class="container-fluid srice py-5">
      <div class="container py-5">
        <div class="sec-head" data-aos="fade-up"><span class="sec-badge">Registration</span><h2 class="sec-title">Create Your <em>Profile</em></h2><p class="sec-sub">Join thousands of law enforcement professionals already connected nationwide.</p></div>
        <div class="row">
          <div class="col-lg-5">
            <form [formGroup]="form2" class="text-center form-shell" data-aos="fade-up" data-aos-duration="900" data-aos-delay="100">
              <h4 class="mb-4 form-title">Search For The UMYO Police</h4>
              <div class="row">
                <div class="col-lg-6 mb-4">
                  <input
                    type="name"
                    formControlName="selectedName"
                    class="form-input"
                    placeholder="Name"
                  />
                </div>

                <div class="col-lg-6 mb-4">
                  <input
                    type="name"
                    formControlName="selectedDepartmentName"
                    class="form-input"
                    placeholder="Name of Department"
                  />
                </div>

                <!-- city here -->
                <div class="col-lg-6 mb-4">
                  <input
                    type="text"
                    formControlName="selectedCity"
                    class="form-input"
                    placeholder="City of Department"
                  />
                </div>

                <div class="col-lg-6 mb-4">
                  <select
                    class="form-input"
                    aria-label="Default select example"
                    formControlName="selectedTypeOfOfficer"
                  >
                    <option selected value="" disabled>Type of Officers</option>
                    <option *ngFor="let item of officerType" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-4">
                  <select
                    class="form-input"
                    aria-label="Default select example"
                    formControlName="selectedOfficerRanking"
                  >
                    <option selected value="" disabled>Officers Ranking</option>
                    <option *ngFor="let item of officerRanking" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-4">
                  <select
                    class="form-input"
                    aria-label="Default select example"
                    formControlName="selectedStateType"
                  >
                    <option selected value="" disabled>State</option>
                    <option *ngFor="let item of state" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-4">
                  <select
                    class="form-input"
                    aria-label="Default select example"
                    formControlName="selectedGender"
                  >
                    <option selected value="" disabled>Gender</option>
                    <option *ngFor="let item of gender" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-4">
                  <select
                    class="form-input"
                    aria-label="Default select example"
                    formControlName="selectedRace"
                  >
                    <option selected value="" disabled>Race</option>
                    <option *ngFor="let item of race" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-4">
                  <input
                    type="name"
                    formControlName="selectedBussniesSupporter"
                    class="form-input"
                    placeholder="Business Supporters"
                  />
                </div>

                <div class="col-lg-6 mb-4">
                  <select
                    class="form-input"
                    aria-label="Default select example"
                    formControlName="selectedBussniesType"
                  >
                    <option selected value="" disabled>Business Type</option>
                    <option *ngFor="let item of businessType" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-4">
                  <input
                    type="text"
                    formControlName="selectedBussniesCity"
                    class="form-input"
                    placeholder="Business City"
                  />
                </div>

                <div class="col-lg-6 mb-4">
                  <select
                    class="form-input"
                    aria-label="Default select example"
                    formControlName="selectedBussniesState"
                  >
                    <option selected value="" disabled>Business State</option>
                    <option *ngFor="let item of businessState" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 mb-4">
                  <button
                    type="submit"
                    class="form-btn"
                    (click)="searchCards()"
                    [disabled]="!form2.valid"
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>

            <div class="form-btn mt-3">
              <p class=" mb-4">Cards:</p>
              <p
                class=" mb-4"
                style="cursor: pointer"
                [routerLink]="'/cards/share-card/' + card.id"
                *ngFor="let card of cardsSearched"
              >
                {{ card.cardTitle }}
              </p>
            </div>
          </div>
          <div class="col-lg-7 mt-5">
            <div class="content">
              <!-- Nav pills -->
              <ul class="nav nav-pills" role="tablist">
                <li class="nav-item" style="cursor: pointer">
                  <a
                    class="nav-link "
                    (click)="checkRoute()"
                    [class.active]="showLoginTab"
                    data-toggle="pill"
                    >Login</a
                  >
                </li>
                <li class="nav-item" style="cursor: pointer">
                  <a
                    class="nav-link"
                    (click)="checkRoute()"
                    [class.active]="!showLoginTab"
                    data-toggle="pill"
                    >Register</a
                  >
                </li>
              </ul>

              <!-- Tab panes -->
              <div class="tab-content form-shell rounded p-4">
                <div
                  id="login"
                  class="container tab-pane"
                  [class.active]="showLoginTab"
                >
                  <form [formGroup]="form">
                    <div class="row">
                      <h1 class="form-title text-center">UMYO For UMYO Police</h1>
                      <p class="sec-sub text-center">
                        Register to Connect with UMYO Police
                      </p>

                      <br /><br /><br /><br /><br /><br />
                      <h2 class="form-title">Login</h2>
                      <div class="col-md-12 mb-5">
                        <div class="form-group">
                          <label class="form-label" 
                            >Email *
                          </label>
                          <input
                            type="email"
                            id="email"
                            class="form-input"
                            formControlName="email"
                            required
                          />
                          <div
                            *ngIf="
                              form.get('email')?.hasError('required') &&
                              form.get('email')?.touched
                            "
                            class="text-danger"
                          >
                            Email is required.
                          </div>
                          <div
                            *ngIf="
                              form.get('email')?.hasError('email') &&
                              form.get('email')?.touched
                            "
                            class="text-danger"
                          >
                            Invalid email format.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mb-5">
                        <div class="form-group">
                          <label class="form-label"
                            >Password *
                          </label>
                          <input
                            type="password"
                            id="password"
                            class="form-input"
                            formControlName="password"
                            required
                          />
                          <div
                            *ngIf="
                              form.get('password')?.hasError('required') &&
                              form.get('password')?.touched
                            "
                            class="text-danger"
                          >
                            Password is required.
                          </div>
                        </div>
                        <div class="form-group" style="padding-top: 10px">
                          <label
                          class="form-label"
                            style="
                              
                              text-decoration: underline;
                              cursor: pointer;
                            "
                            [routerLink]="['/forgot-password']"
                            >Forgot Password?
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-group">
                          <div
                            class="custom-control custom-checkbox custom-checkbox-lg d-flex align-items-center"
                          >
                            <input
                              style="width: 1rem; height: 1rem"
                              type="checkbox"
                              class="custom-control-input "
                              id="ageCheckbox"
                            />
                            <label
                              class="form-label mb-0"
                              for="ageCheckbox"
                              style="
                                
                                margin-left: 10px;
                              "
                            >
                              Are you above 13 years old?
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      (click)="openAgeModal('login')"
                      type="submit"
                      class="form-btn mt-3 "
                      style="margin: auto; display: block"
                      [disabled]="!form.valid"
                    >
                      Submit
                    </button>
                   
                  </form>
                </div>

                <div
                  id="regis"
                  class="container tab-pane"
                  [class.active]="!showLoginTab"
                >
                  <form [formGroup]="form3">
                    <div class="row justify-content-center">
                      <h1 class="text-center form-title">UMYO Pro</h1>
                      <div class="col-md-3 my-5">
                        <p class="text-center sec-sub">starting at</p>
                        <h1 class="text-center sec-sub">$5/mo</h1>
                        <p class="text-center sec-sub">per agent</p>
                      </div>
                      <div class="col-md-1 my-5 d-none d-lg-block">
                        <div class="verticle"></div>
                      </div>
                      <div class="col-md-6 my-5">
                        <p class="sec-sub">Includes:</p>
                        <li class="sec-sub">40% off all UMYO products</li>
                        <li class="sec-sub">3 free property listings per agent</li>
                        <li class="sec-sub">Free standard CRM integrations</li>
                      </div>
                      <h2 class="mb-3 form-title">Register</h2>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <div class="form-group">
                          <label class="form-label" 
                            >Frist Name *</label
                          >
                          <input
                            type="text"
                            formControlName="registerFirstName"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                !form3.get('registerFirstName')?.touched &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="form-group">
                          <label class="form-label"
                            >Last Name *
                          </label>
                          <input
                            type="text"
                            formControlName="registerLastName"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                !form3.get('registerLastName')?.touched &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-group">
                          <label class="form-label"
                            >Phone Number *</label
                          >
                          <input
                            type="text"
                            formControlName="registerPhone"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                !form3.get('registerPhone')?.touched &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>

                      <div class="col-md-6 mb-3">
                        <div class="form-group">
                          <label class="form-label"
                            >Email *</label
                          >
                          <input
                            type="email"
                            formControlName="registerEmail"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                (!form3.get('registerEmail')?.touched ||
                                  !form3.get('registerEmail')?.valid) &&
                                submitButtonClicked &&
                                (!form3.valid || form3.hasError('emailMismatch'))
                            }"
                          />
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="form-group">
                          <label class="form-label"
                            >Confirm Email *</label
                          >
                          <input
                            type="email"
                            formControlName="registerConfirmEmail"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                (!form3.get('registerConfirmEmail')?.touched ||
                                  !form3.get('registerConfirmEmail')?.valid) &&
                                submitButtonClicked &&
                                (!form3.valid || form3.hasError('emailMismatch'))
                            }"
                          />
                        </div>
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-group">
                          <label class="form-label"
                            >Password * ( Length Should be greater than 6 )
                          </label>
                          <input
                            type="password"
                            class="form-input"
                            required
                            formControlName="registerPassword"
                            [ngClass]="{
                              'invalid-input':
                                (!form3.get('registerPassword')?.touched ||
                                  !form3.get('registerPassword')?.valid) &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>

                      <!-- depart name -->

                      <div class="col-lg-6 mb-4">
                        <div class="form-group">
                          <label class="form-label"
                            >Department Name *</label
                          >
                          <input
                            type="text"
                            formControlName="registerDepartmentName"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                !form3.get('registerDepartmentName')?.touched &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>
                      <!-- normal city -->

                      <div class="col-lg-6 mb-4">
                        <div class="form-group">
                          <label class="form-label"
                            >Department City *</label
                          >
                          <input
                            type="text"
                            formControlName="registerCityType"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                !form3.get('registerCityType')?.touched &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>

                      <!-- type of depart -->

                      <div class="col-lg-6 mb-4">
                        <label class="form-label"
                          >Type of Officer *
                        </label>
                        <select
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerTypeOfOfficer')?.touched ||
                                !form3.get('registerTypeOfOfficer')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                          required
                          formControlName="registerTypeOfOfficer"
                          class="form-input"
                          aria-label="Default select example"
                        >
                          <option value="" disabled selected>
                            Please Select
                          </option>
                          <option *ngFor="let item of officerType" [value]="item">
                            {{ item }}
                          </option>
                        </select>
                      </div>

                      <!-- Officers Ranking -->

                      <div class="col-lg-6 mb-4">
                        <label class="form-label"
                          >Officers Ranking *
                        </label>
                        <select
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerOfficerRanking')?.touched ||
                                !form3.get('registerOfficerRanking')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                          required
                          formControlName="registerOfficerRanking"
                          class="form-input"
                          aria-label="Default select example"
                        >
                          <option value="" disabled selected>
                            Please Select
                          </option>
                          <option
                            *ngFor="let item of officerRanking"
                            [value]="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>

                      <div class="col-lg-6 mb-4">
                        <label class="form-label"
                          >State *
                        </label>
                        <select
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerStateType')?.touched ||
                                !form3.get('registerStateType')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                          required
                          formControlName="registerStateType"
                          class="form-input"
                          aria-label="Default select example"
                        >
                          <option value="" disabled selected>
                            Please Select
                          </option>
                          <option *ngFor="let item of state" [value]="item">
                            {{ item }}
                          </option>
                        </select>
                      </div>

                      <!-- gender -->

                      <div class="col-lg-6 mb-4">
                        <label class="form-label"
                          >Gender *
                        </label>
                        <select
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerGenderType')?.touched ||
                                !form3.get('registerGenderType')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                          required
                          formControlName="registerGenderType"
                          class="form-input"
                          aria-label="Default select example"
                        >
                          <option value="" disabled selected>
                            Please Select
                          </option>
                          <option *ngFor="let item of gender" [value]="item">
                            {{ item }}
                          </option>
                        </select>
                      </div>

                      <!-- race -->

                      <div class="col-lg-6 mb-4">
                        <label class="form-label"
                          >Race *
                        </label>
                        <select
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerRaceType')?.touched ||
                                !form3.get('registerRaceType')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                          required
                          formControlName="registerRaceType"
                          class="form-input"
                          aria-label="Default select example"
                        >
                          <option value="" disabled selected>
                            Please Select
                          </option>
                          <option *ngFor="let item of race" [value]="item">
                            {{ item }}
                          </option>
                        </select>
                      </div>

                      <div class="col-lg-6 mb-4">
                        <div class="form-group">
                          <label class="form-label"
                            >Business Supporters *</label
                          >
                          <input
                            type="text"
                            formControlName="registerBusinessSupporter"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                !form3.get('registerBusinessSupporter')
                                  ?.touched &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>
                      <!-- busniess type -->

                      <div class="col-lg-6 mb-4">
                        <label class="form-label"
                          >Business Type *
                        </label>
                        <select
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerBusiness')?.touched ||
                                !form3.get('registerBusiness')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                          required
                          formControlName="registerBusiness"
                          class="form-input"
                          aria-label="Default select example"
                        >
                          <option value="" disabled selected>
                            Please Select
                          </option>
                          <option
                            *ngFor="let item of businessType"
                            [value]="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>

                      <!-- busniness city -->

                      <div class="col-lg-6 mb-4">
                        <div class="form-group">
                          <label class="form-label"
                            >Business City *</label
                          >
                          <input
                            type="text"
                            formControlName="registerBussniesCity"
                            class="form-input"
                            required
                            [ngClass]="{
                              'invalid-input':
                                !form3.get('registerBussniesCity')?.touched &&
                                submitButtonClicked &&
                                !form3.valid
                            }"
                          />
                        </div>
                      </div>

                      <!-- business state -->

                      <div class="col-lg-6 mb-4">
                        <label class="form-label"
                          >Business State *
                        </label>
                        <select
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerBussniesState')?.touched ||
                                !form3.get('registerBussniesState')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                          required
                          formControlName="registerBussniesState"
                          class="form-input"
                          aria-label="Default select example"
                        >
                          <option value="" disabled selected>
                            Please Select
                          </option>
                          <option
                            *ngFor="let item of businessState"
                            [value]="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-12 mb-3">
                        <div class="form-group">
                          <label class="form-label"
                            >Enter Referral Code</label
                          >
                          <input
                            type="text"
                            formControlName="registerReferralCode"
                            class="form-input"
                          />
                        </div>
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-group">
                          <div
                            class="custom-control custom-checkbox custom-checkbox-lg d-flex align-items-center"
                          >
                            <input
                              style="width: 1rem; height: 1rem"
                              type="checkbox"
                              class="custom-control-input "
                              id="ageCheckbox"
                            />
                            <label
                              class="form-label mb-0"
                              for="ageCheckbox"
                              style="
                                
                                margin-left: 10px;
                              "
                            >
                              Are you above 13 years old?
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div (click)="submitForm()">
                      <button
                        (click)="openAgeModal('signup')"
                        [disabled]="!form3.valid"
                        class="form-btn mt-3 "
                        style="margin: auto; display: block"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- TAGLINE -->
  <section class="section dark" style="padding:50px 24px 60px;">
    <div style="text-align:center;" data-aos="zoom-in">
      <span class="gold-bar"></span>
      <p style="font-family:'Oswald',sans-serif;font-size:clamp(18px,3vw,32px);font-weight:700;color:var(--white);margin:24px 0 10px;text-transform:uppercase;letter-spacing:3px;">Built for Officers. Powered by Community.</p>
      <p style="font-family:'Source Serif 4',serif;font-size:clamp(16px,2.5vw,22px);font-style:italic;color:var(--silver);">Network. Support. Grow. Recognize.</p>
      <span class="gold-bar" style="margin-top:24px;display:block;"></span>
      <p style="font-family:'Rajdhani',sans-serif;font-size:14px;font-weight:700;letter-spacing:3px;color:var(--gold);margin-top:24px;text-transform:uppercase;">No officer left unrecognized &middot; No business left disconnected</p>
      <a routerLink="/" style="display:inline-block;margin-top:20px;font-family:'Rajdhani',sans-serif;font-size:15px;font-weight:700;letter-spacing:2px;color:var(--gold);text-decoration:none;border-bottom:1px solid rgba(201,151,58,0.4);padding-bottom:3px;">🌐 www.umyopd.site</a>
    </div>
  </section>



<footer class="site-footer">
  <div class="footer-inner">
    <div>
      <div class="footer-logo">
        <img src="assets/img/logo.png" alt="Police Officers Connect">
      </div>
      <div class="footer-brand">Police Officers Connect</div>
      <div class="footer-sub-txt">UMYO Network</div>
      <a class="footer-url" rputerLink="/">🌐 www.umyopd.site</a>
    </div>
    <div>
      <div class="footer-col-title">Navigation</div>
      <ul class="footer-links ps-0">
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/about">About the Platform</a></li>
        <li><a routerLink="/support">Officer &amp; Family Support</a></li>
        <li><a routerLink="/business">For Businesses</a></li>
        <li><a routerLink="/services">Servcies</a></li>
        <li><a routerLink="/cf">Card Features</a></li>
        <li><a routerLink="/terms">Terms & Condition</a></li>
      </ul>
    </div>
    <div>
      <div class="footer-col-title">Contact</div>
      <div class="footer-contact">
        <div><strong style="color:var(--white);">UMYO Police Connect</strong></div>
        <div>UMYO Network</div>
        <div>3225 Martin Luther King Blvd</div>
        <div>Dallas, Texas 75210</div>
        <div><a routerLink="/">www.umyopd.site</a></div>
      </div>
    </div>
  </div>
</footer>
<div class="footer-bottom">&#169; 2025 UMYO Police Connect &middot; Built for Officers &middot; Powered by Community &middot; Network. Support. Grow. Recognize.</div>



<!-- packages modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPackageModal, 'd-block': showPackageModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Select One Package
        </h5>
        <button type="button" class="close" (click)="closePackageModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: scroll">
        <div class="row">
          <div class="col-md-6" *ngFor="let package of packages; let i = index">
            <div class="outerCard" style="min-height: 30vh; cursor: pointer">
              <div
                class="card"
                [ngClass]="{ cardSelect: selectedPackage === package }"
                (click)="selectPackage(package)"
              >
                <div class="card-body">
                  <h5 class="card-title" style="color: rgb(35, 149, 243)">
                    $
                    {{ package.net_price ? package.net_price : package.price }}
                    <sup
                      style="
                        text-decoration: line-through;
                        font-size: 20px;
                        color: gray;
                        padding-left: 15px;
                      "
                      *ngIf="package.net_price"
                      >{{ package.price }}</sup
                    >
                  </h5>
                  <p class="card-text">Cards Limit: {{ package.limit }}</p>
                  <p class="card-duration">Duration: {{ package.expire_in }}</p>

                  <div
                    class="description-container"
                    style="max-height: 100px; overflow-y: auto"
                  >
                    <p class="card-description">{{ package.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100" *ngIf="(i + 1) % 2 === 0"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          (click)="closePackageModal()"
          type="button"
          class="btn btn-secondary"
        >
          Close
        </button>

        <div
          *ngIf="selectedPackage?.price != '0'"
          [ngClass]="{
            hidden: selectedPackage == null || selectedPackage?.price == '0',
            paymentButtons: selectedPackage != null
          }"
        >
          <!-- <div id="paypal-button-container"></div> -->
          <!-- hide stripe -->
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="openStripeModal()"
          >
            Stripe
          </button>
          <!-- <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="paypalClick()"
          >
            paypal
          </button> -->
        </div>
        <div *ngIf="selectedPackage?.price == '0'">
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="continuePaymentButton()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>{{ paypalTitleMessage }}</h3>
          <p style="padding-top: 15px">{{ paypalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- stripe modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showStripeModal, 'd-block': showStripeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Pay Through Stripe
        </h5>
        <button type="button" class="close" (click)="closeStripeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <h3>
            Amount
            {{ selectedPackage?.net_price ? selectedPackage?.net_price : selectedPackage?.price }}
          </h3>
           <div class="row" ngxStripeCardGroup>

            <div class="col-md-12" style="padding-top: 17px">
              <label style="font-size:17px; font-weight:600; padding-bottom:8px;">Card Number</label>
              <div style="border:1px solid #ced4da; border-radius:4px; padding:10px;">
                <ngx-stripe-card-number [options]="cardOptions"></ngx-stripe-card-number>
              </div>
            </div>

            <div class="col-md-6" style="padding-top: 17px">
              <label style="font-size:17px; font-weight:600; padding-bottom:8px;">Expiry Date</label>
              <div style="border:1px solid #ced4da; border-radius:4px; padding:10px;">
                <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
              </div>
            </div>

            <div class="col-md-6" style="padding-top: 17px">
              <label style="font-size:17px; font-weight:600; padding-bottom:8px;">CVC</label>
              <div style="border:1px solid #ced4da; border-radius:4px; padding:10px;">
                <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>
              </div>
            </div>

          </div>
          <div class="row mt-3">
            <div class="col-md-12" style="display:flex; justify-content:center; padding-top:10px;">
              <button type="button" class="btn btn-primary" (click)="pay()">
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeStripeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showAgeModal, 'd-block': showAgeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Are You 18+ of your age?</h3>
        </div>
        <p style="padding: 8px">
          You must be at least 13 years old to use the Service. However,
          children of all ages may use the Service and PLTalk Kids (where
          available) if enabled by a parent or legal guardian. Permission by
          Parent or Guardian If you are under 18, you represent that you have
          your parent or guardian’s permission to use the Service. Please have
          them read this Agreement with you. If you are a parent or legal
          guardian of a user under the age of 18, by allowing your child to use
          the Service, you are subject to the terms of this Agreement and
          responsible for your child’s activity on the Service. You can find
          tools and resources to help you manage your family’s experience on
          PLTalk in our Help Center
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirmAge()">
          Yes
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAgeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Confirming Payment...</h3>
        </div>
      </div>
    </div>
  </div>
</div>



<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPolicyModal, 'd-block': showPolicyModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="privacyModalLabel">Privacy Policy</h5>
        <button type="button" class="close" (click)="closePolicyModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <pre
            style="
              max-height: 70vh;
              white-space: pre-wrap;
              overflow-x: hidden;
              overflow-y: scroll;
            "
          >
              Privacy Policy
  
  Last modified: January 10, 2022
  
  Who We Are
  
  Welcome! We are UMYO Police   Inc., a Texas corporation, or as we prefer to be known, "UMYO Police  ,"
  "we," "our," or "us." Our mission is to revolutionize how the world connects! We provide
  products,services, and technologies ("Products") allowing users ("Users") to organize,
  display, and share information with their contacts through our software, mobile
  application, and website (collectively,"Platform").
  
  We are committed to safeguarding our User’s privacy in accordance with this Privacy Policy
  ("Policy").Please carefully read this Policy to comprehend our policies and practices
  concerning your information and how we handle it. If you disagree with our policies and
  practices, please refrain from using our Platform or purchasing our Products.
  
  How to Contact Us
  
  If you have any questions about our practices or this Policy, please reach out to us via
  email at data-privacy@UMYO Police  .com or by mail at UMYO Police   Inc., Attn: Data Privacy
  Officer, 1709 Martin Luther King Blvd Dallas, Texas, 75215
  
  Application of this Policy
  
  Upon accessing our Platform or utilizing our Products, you become a User and agree to
  this Policy, our Data Processing Addendum, and our Terms of Service and Sale
  (collectively, "Policies").
  
  This Policy delineates the types of information we may collect from you or that you may
  provide to us when interacting with our Platform or Products. It further outlines
  our practices for collecting,
  using, maintaining, protecting, and disclosing that information.
  
  Categories of Information We Collect or Receive
  
  Our Platform and Products empower Users to customize their pages and profiles by
  uploading and linking content and information, shareable with other Users or third
  parties. The information provided by a User on the Platform can be extensive. We
  may receive information directly from you or automatically as you access, use, or
  interact with our Platform or Products.
  
  The categories of information we collect or receive include:
  
  - **Identity or Contact Information:** Your first name, last name, or similar
   identifier title, postal addresses, unique personal identifiers, online
  identifiers, IP addresses, email addresses, social media accounts or identifiers
  (e.g., username), age, date of birth, or other similar contact information
  or forms of identification.
  
  - **Transaction Information:** Details about payments to and from you, as well
   as other details of subscriptions and services you have purchased from us.
  
  - **Content Data Information:** Any content you post on the Platform, such as
    pictures, third-party links, documents, writings, preference settings, messages,
    comments, and other contributions, along with metadata about them.
  
  - **Marketing and Communications Information:** Your preferences for receiving
    marketing communications from us and your communication preferences.
    Correspondence content, if any, may be retained.
  
  - **Behavioral and Usage Information:** Details of your access, use, or 
    interaction with our Platform or Products, including traffic data, location
    data, logs, and other communication data.
  
  - **Technical Information:** IP address, browser type and version, time zone
    setting and location, browser plug-in types and versions, operating system
    and platform, and other technology on the devices you use to access our Platform.
  
  - **Aggregated Data or Information:** We may collect, use, and share aggregated 
    data or information such as statistical or demographic data derived from your 
    Personal Information.
  
  Because Users can upload various information on our Platform, we may also receive
  sensitive information, such as your date of birth, racial or ethnic origin, sex,
  political views, affiliations, veteran or military status, religious or philosophical
  views, or similar information. We do not mandate the provision of Sensitive Information,
  but such information may be indirectly collected by us through our hosting of the Platform.
  
  Our Platform also allows you to upload and share information that is not Personal Information
  or Sensitive
  Information, such as your hobbies, pictures, links, descriptions, messages, and comments
  ("Other Information"). As our Platform permits you to choose the Information associated
  with your account, we may link Other Information to Personal or Sensitive Information 
  aboutyou.
  
  For more information on our use of cookies, logs, web beacons, and other tracking
  technologies,refer to the "Third-Party Sources, Cookies, and Other Tracking
  Technologies" section below.
  
  Third-Party Sources, Cookies, and Other Tracking Technologies
  
  We may also collect or receive Personal Information from third-party sources, and the Platform
  may include links to other sites. Any Information you provide on linked pages is submitted
  directly to the respective third-party and is subject to their terms and policies. This 
  Policy does not extend to such linked third-party sites, and we disclaim responsibility 
  for the content, privacy, security practices, and policies of these external sites or any
  other sites linked to or from our Platform.
  
  Certain Information on the Platform may be served by third parties, including advertisers,
  ad networks and servers, content providers, and application providers. These third parties
  may utilize cookies independently or in conjunction with web beacons or other tracking
  technologies to collect Information about you. The Information they gather may be linked
  to your Personal Information or Sensitive Information, or they may collect Information,
  including Personal Information, about your activities across different websites and online
  services.This Information may be used to provide you with interest-based advertising or other
  targeted content. We do not oversee third-party tracking technologies or their usage. For 
  inquiries regarding advertisements or other targeted content, please directly contact the 
  responsible provider.
  
  We may collect Information regarding your Platform usage, encompassing the pages and links
  viewed, time spent on our Platform, demographic data such as server locations, connection
  speed, and other non-identifying Information. Like most online services, we employ cookies
  , log files, clear GIFs, tracking pixels, web beacons, and other technologies that may collect
  Personal Information.
  
  Upon visiting our Platform, one or more "cookies" – small data files – may be sent to your
  device to uniquely identify your browser, enabling us to enhance your navigation experience.
  Cookies may convey Information about your Platform or Products usage to provide you with a 
  more personalized experience. Persistent cookies remain on your device after closing your 
  browser, allowing your browser to use them in subsequent visits. These can be removed by 
  following your web browser's instructions. Session cookies are temporary and vanish after 
  closing your browser.Our Platform may utilize the following types of cookies, logs, web
  beacons, and other tracking 
   technology:
  
  - **Essential Cookies:** Necessary to provide you with services available on our Platform, 
  facilitating actions like logging in to secure areas and expediting Content loading.
  
  - **Functionality Cookies:** Allow us to remember your choices, such as login information, 
    providing a more personalized experience.
  
  - **Analytics and Performance Cookies:** Collect Information about traffic to our Platform 
    and Users' interactions to enhance Platform efficiency and gather aggregated, anonymous
    demographic data.
    Third-party tools and services may be utilized for this purpose.
  
  - **Targeted and Advertising Cookies:** Track browsing habits to show relevant content.
   Information about browsing history may group Users with similar interests, enabling
    third-parties to display ads matching those interests.
  
  - **Social Media Cookies:** Activate when sharing or engaging with Content on social
    media platforms,helping track conversions, optimize ads, and build targeted audiences.
  
  - **Log Files:** Automatically reported by your browser, recording information such
   as web requests, IP addresses, browser types, and pages viewed. Servers automatically
  capture this data whenever you access our Platform.
  
  ### How Can I Disable Cookies?
  
  You can typically configure your web browser to block all cookies or prompt you when
  a cookie is being sent.To do this, follow the instructions provided by your browser,
  usually located within the “settings,” “help,” or “tools” function. Many browsers
  are set to accept cookies by default until you modify your settings.
  
  Should you choose not to accept our cookies, it may result in some inconvenience
  during your use of our Platform, and certain features may not operate correctly.
  For instance, we may be unable to recognize your device, necessitating you to log
  in each time you visit our Platform.
  
  For more details on cookies, including viewing and managing cookies on your device, 
  visit www.allaboutcookies.org or www.whatarecookies.com.
  
  As of now, we do not acknowledge web browsers’ “do not track” signals that offer an
  opt-out method from collecting Information about User activities on the Platform.
  If we adopt this practice in the future, relevant information will be provided in
  this Policy.
  
  ### How We Use Your Information
  
  We utilize the Information collected about you or provided by you, including any
  Personal Information:
  
  - To present our Platform and enhance its contents, providing a personalized
    and improved experience for Users.
  - To furnish information, products, or services requested by you, responding
    to inquiries or facilitating purchases 
    and deliveries.
  - To enable your participation in interactive features, allowing the sharing
    of Personal Information with other Users.
  - To send notices regarding your accounts, pages, or subscriptions, including
    expiry and renewal notifications.
  - To fulfill our contractual obligations and enforce rights, including
    billing and collection.
  - To inform you of changes to our Platform, Products, or services.
  - To uphold the safety, security, and integrity of the Platform, Products,
    databases, and technological assets.
  - For testing, research, analysis, and product development, enhancing and
     evolving our Platform and Products.
  - To respond to law enforcement requests and comply with applicable law,
    court orders, or governmental regulations.
  - In any other manner as described when providing the Information or as
     outlined in applicable law, including the CCPA and GDPR.
  - For any other purpose with your consent.
  
  ### Disclosure of Your Information
  
  We may share your Information, including Personal Information, by disclosing
  it to third parties for the provision of our Platform, its Content, and security,
  or for marketing and selling our Platform or Products. 
  These disclosures occur under written contracts specifying purposes,
  confidentiality requirements, and prohibiting use for any purpose other than contract
   performance. We do not sell your Personal Information.
  
  For Users with an account linked to a “UMYO Police   for Teams” subscription, the administrator 
  associated with your “UMYO Police   for Teams” account may manage, access, view, or store your
  Information, including Personal Information. We do not control or limit your account's
  accessibility, and we are not responsible for the administrator's access, disclosure, or
  processing of your Information.
  
  Within the last twelve (12) months, we have disclosed Information, as described in this Policy:
  
  - In connection with your use of our Platform or Products, enabling the sharing of Personal
    Information with other Users.
  - To our service providers, affiliates, agents, subprocessors, advertising partners, 
    internet service providers, data analytics providers, and related third parties, supporting
    Platform and Product functions.
  - To our processors and subprocessors, engaging specific service providers to assist in
     Platform and Product support.
  
  **List of Subprocessors:**
  
  - **Google LLC:** Cloud Service Provider (United States)
  - **Stripe:** Payment Processor (United States)
  - **Hubspot:** Marketing, Sales (CRM), and Support Software Platform (United States)
  - **Chili Piper:** Scheduling Software (United States)
  - **Zapier:** Workflow Integration Software (United States)
  - **Slack:** Messaging and Communication Platform (United States)
  - **Amplitude:** Product and Data Analytics (United States)
  - **Shopify:** Ecommerce Platform (Canada and jurisdictions per Shopify’s policies)
  - **Cloudflare Inc.:** Web Traffic Optimization and Distribution Service (United States)
  - **Covve Visual Network Limited:** Physical business card scanner API (Cyprus)
  - **Rollbar:** Error Monitoring (United States)
  - **Heroku:** Cloud Hosting Provider (United States)
  - **AWS:** Cloud Hosting Provider (United States)
  - **Fivetran:** ETL Tooling (United States)
  - **Looker:** BI (Business Intelligence) tooling (United States)
  - **Cloudinary:** Image hosting API (United States)
  - **Newrelic:** APM (Application Performance Monitoring) (United States)
  - **Passsource:** API (United States)
  - **Klaviyo:** Marketing automation (United States)
  
  **User Data Privacy Policy**
  
  **Effective Date: [Date]**
  
  Welcome to UMYO Police  ! This User Data Privacy Policy ("Policy") outlines how we collect,
  use, disclose, and protect your information when you use our platform, products, and
  services ("Platform" or "Products"). Please read this Policy carefully to understand
  our practices regarding your information and how we will treat it.
  
  ### 1. **How Can I Disable Cookies?**
  
  You have the ability to configure your web browser to block cookies or prompt
  you when a cookie is being sent. Refer to your browser's settings, usually
  located in the "settings," "help," or "tools" function. Please note that
  if you choose to disable our cookies, it may impact your experience on the Platform,
  and certain features may not operate correctly. For more information on cookies,
  including how tomanage them, visit [www.allaboutcookies.org](www.allaboutcookies.org)
  or [www.whatarecookies.com](www.whatarecookies.com).
  
  As of now, we do not acknowledge "do not track" signals from web browsers. If this
  changes in the future, we will provide relevant information in this Policy.
  
  ### 2. **How We Use Your Information**
  
  We use the information collected or provided by you for various purposes, including
  but not limited to:
  
  - Presenting and enhancing the Platform.
  - Providing information, products, or services as requested.
  - Enabling participation in interactive features and sharing information with other Users.
  - Sending notices regarding accounts, pages, or subscriptions.
  - Fulfilling contractual obligations, including billing and collection.
  - Informing you of changes to our Platform, Products, or services.
  - Upholding the safety, security, and integrity of our Platform and Products.
  - Conducting testing, research, analysis, and product development.
  - Responding to law enforcement requests and complying with applicable laws.
  
  ### 3. **Disclosure of Your Information**
  
  We may share your information, including Personal Information, with third parties for various 
  purposes,such as providing our Platform, securing it, and marketing or selling our Products.
  These disclosures are governed by written contracts specifying purposes and confidentiality
  requirements. We do not sell your Personal Information.
  
  **List of Subprocessors:**
  - Google LLC (Cloud Service Provider, United States)
  - Stripe (Payment Processor, United States)
  - Hubspot (Marketing, Sales, and Support Software Platform, United States)
  - Chili Piper (Scheduling Software, United States)
  - Zapier (Workflow Integration Software, United States)
  - Slack (Messaging and Communication Platform, United States)
  - Amplitude (Product and Data Analytics, United States)
  - Shopify (Ecommerce Platform, Canada and jurisdictions per Shopify’s policies)
  - Cloudflare Inc. (Web Traffic Optimization and Distribution Service, United States)
  - Covve Visual Network Limited (Physical business card scanner API, Cyprus)
  - Rollbar (Error Monitoring, United States)
  - Heroku (Cloud Hosting Provider, United States)
  - AWS (Cloud Hosting Provider, United States)
  - Fivetran (ETL Tooling, United States)
  - Looker (BI tooling, United States)
  - Cloudinary (Image hosting API, United States)
  - Newrelic (APM, United States)
  - Passsource (API, United States)
  - Klaviyo (Marketing automation, United States)
  
  ### 4. **Where We Store Your Information**
  
  We maintain our Platform in the United States, and your information may be stored,
  processed, and accessed in the U.S. or elsewhere by us, our employees, contractors,
  and third parties. By using our Platform and providing your information, you consent
  to the export of Personal Information to the United States, understanding that U.S.
  laws may differ from those in your country.
  
  ### 5. **How Long We Store Your Information**
  
  We retain your information for as long as reasonably necessary for the purposes
  outlined in this Policy, unless a longer retention period is required by law. We
  may keep your information for business interests, audits, legal compliance, dispute
  resolution, and agreement enforcement.
  
  ### 6. **Your Rights Related to Your Personal Information**
  
  You may have rights under laws such as the CCPA and GDPR. These rights may include:
  
  - Requesting access to your Personal Information.
  - Right to Know (CCPA) – Receiving information about the collection and use of your
     Personal Information.
  - Requesting correction of your Personal Information.
  - Requesting erasure of your Personal Information.
  - Objecting to processing or requesting restriction of processing.
  - Requesting the transfer of your Personal Information.
  - Withdrawing consent.
  
  ### 7. **How to Exercise Your Rights**
  
  To exercise your rights or inquire about your Personal Information, contact us at 
  [data-privacy@UMYO Police  .com] (mailto:data-privacy@UMYO Police  .com) or by mail at
  UMYO Police   Inc., Attn: Data Privacy Officer, [Address].
  
  We will confirm receipt of your request within ten (10) business days and aim to
  respond within one month, unless the request is complex. If applicable, any disclosures
  will cover the 12-month period preceding the request.
  
  ### 8. **Non-Discrimination**
  
  We do not discriminate against you for exercising your rights. We will not deny goods or
  services, charge different prices, or provide different quality levels based on your
  exercise of privacy rights, unless permitted by law.
  
  ### 9. **How We Protect Your Information**
  
  We implement measures to secure your information from loss and unauthorized access.
  All information is stored on secure servers, and payment transactions are encrypted
  using SSL technology.
  
  ### 10. **Children Under the Age of 16**
  
  Our Platform is not intended for children under 16. We do not knowingly collect
  Personal Information from children under 16. If you are under 16, please do not
  use the Platform or provide any information. If we learn of such information, we
  will delete it promptly.
  
  ### 11. **Opting Out of Sale of Personal Information**
  
  We do not sell Personal Information. If you are 16 or older, you can direct us not
  to sell your information at any time by contacting us at 
  [data-privacy@UMYO Police  .com](mailto:data-privacy@UMYO Police  .com) or by mail at
  UMYO Police   Inc., Attn: Data Privacy Officer, 1709 MLK BLVD Dallas, Texas 75215
  
  **Changes to Our Privacy Policy at UMYO Police  **
  
  You acknowledge that this Policy is subject to modification by us at any time,
  without prior written notice,and solely at our discretion. Any revisions to this
  Policy will take effect on the "Last Updated Date" or "Last Revised Date"
  indicated on the Platform. Therefore, it is advisable to review our Policies before
  making any purchases or using our Products, Platform, or associated services. Your
  ongoing use of the Platform or any Product following the "Last Updated Date" or "Last
  Revised Date" will signify your acceptance and agreement to these modifications
  
            </pre
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showRefundModal, 'd-block': showRefundModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="refundModalLabel">Refund Policy</h5>
        <button type="button" class="close" (click)="closeRefundModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <pre
            style="
              max-height: 70vh;
              white-space: pre-wrap;
              overflow-y: scroll;
              overflow-x: hidden;
            "
          >
              **Refund Policy at UMYO Police  **
  
  **Returns for Defective Items:**
  Our steadfast commitment to delivering high-quality custom items remains unwavering. In the
  event that you receive a defective or damaged item, kindly notify us within 30 days of
  receipt. We will promptly offer a replacement or a full refund for the returned items.
  
  **Return for Customization Issues:**
  If the item received does not align with the agreed-upon customization specifications,
  please inform us within 30 days of receipt. We will collaborate with you to replace
  and reprint it correctly to your satisfaction. In some cases, we may request the return
  of the item to our office to address any issues that occurred during the printing process.
  
  **No Returns for Change of Mind:**
  Due to the personalized nature of our custom items, returns or exchanges stemming from a
  change of mind are not feasible. We encourage you to thoroughly review all customization
  details before confirming your order. This enables us to promptly commence crafting your
  item, ensuring a smooth and efficient process.
  
  **Communication on Specifications:**
  To expedite the process and ensure your custom item exceeds expectations, we rely on
  comprehensive and precise specifications during the ordering process. Your timely
  and detailed communication allows us to swiftly proceed with crafting your custom
  piece, reflecting our commitment to your satisfaction.
  
  If you believe your order requires additional details, please notify us promptly.
  As the fastest custom NFC option on the market, early communication enhances our
  ability to address any potential issues.
  
  **Cancellation Policy:**
  You can cancel your order within 1-2 business days of purchase, provided we haven't
  initiated the creation of your custom item. If cancellation is requested after this
  timeframe, a 10% cancellation fee will be applied to cover the cost of materials and
  work invested in your unique item. This fee will be deducted from your refund.
  
            </pre
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showTermsModal, 'd-block': showTermsModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="termsModalLabel">Terms Of Service</h5>
        <button
          type="button"
          class="close"
          (click)="closeTermsModal()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <pre
            style="
              max-height: 70vh;
              white-space: pre-wrap;
              overflow-y: scroll;
              overflow-x: hidden;
            "
          >
              Welcome to UMYO Police  !
  
  **Terms of Service and Sale - UMYO Police  **
  
  **Last Revised: December 22, 2023**
  
  **Terms of Sale and Service**
  
  **Introduction**
  
  Welcome! We are UMYO Police  , a Delaware corporation, known as "we," "our," or "us." Our mission
  is to redefine how the world connects. We provide Products, Services, and Technologies
  ("Products") that enable Users ("Users") to organize, display, and share information
  with others and third parties ("Services") through our software, mobile application, and
  website (collectively, "Platform").
  
  By submitting an order through the Platform or otherwise ("Order"), you (whether on behalf
  of yourself or an entity you represent) are entering into these Terms of Sale and Service
  ("Terms") with us. You agree to be bound by these Terms and other conditions governing the
  use of our Services, Platform, or the Products offered or sold, such as our Privacy Policy
  and Data Processing Addendum (collectively, "Policies"). If you are under 16, you may not
  use our Platform or Services without parental or guardian permission.
  
  If you disagree with these Terms or our Policies, do not submit an Order or use our
  Platform, Services, or Products.
  
  By agreeing, you confirm that you have the authority to bind yourself and/or the entity
  or company you represent. We may periodically modify these Terms or any Policies at our
  discretion, with the "Last Revised" date indicating such changes.
  
  **Purchase of Products**
  
  (a) When you place an Order, you make an offer to purchase Products according to the
  Order terms, these Terms, and our Policies. An Order is effective upon our acceptance
  or rejection. We may accept or reject Orders at our discretion. Product prices (the
  "Product Purchase Price") are as stated in the Order or, if not in an Order, as
  advertised on our Platform when we accept the Order. Prices exclude taxes; you are
  responsible for such charges.
  
  (b) We select shipment methods and carriers unless specified in the Order. Partial
  shipments are possible at our discretion. You pay for shipped units, including shipping
  and insurance costs unless otherwise stated in the Order.
  
  (c) Products will be delivered to the specified address ("Delivery Point") within a
  reasonable time. Custom Products may have longer processing times. Delivery times are
  estimates, and we are not liable for delays. Title and risk pass upon delivery. If you
  fail to accept delivery, risk passes to you, and we may store the Products at your cost.
  
  (d) Inspect Products within ten (10) days of delivery ("Inspection Period"). Accept or reject
  Nonconforming Products (materially different or defective) during the Inspection Period. If
  notified of Nonconforming Products, ship them to us, and we may replace them.
  
  (e) We warrant Products against significant defects for 1 year ("Warranty Period"). The
  warranty doesn't apply if Products are misused, altered, or used with unauthorized hardware.
  Except for this warranty, we provide no other warranties.
  
  (f) We are not liable for a breach of the warranty unless you give written notice within
  10 days of discovering the defect, allow us to examine the Products, and we verify the
  Nonconforming Products. Remedies for Nonconforming Products are repair, replacement,
  credit, or refund at our discretion.
  
  (g) Your sole remedy for Nonconforming Products is as outlined in Section 2(f).
  
  (h) Changes to Terms in Orders are void unless expressly stated.
  
  **Services**
  
  (a) To use our Services, register and create an account ("Account"). Our Services allow
  Users to create, design, maintain, and share profiles or pages ("Pages"). Subscription
  Levels offer different access levels.
  
  (b) During the Subscription Term, you are granted licensed seats for Services based on
  an accepted Order. Users are responsible for complying with these Terms and our Policies.
  Some Products may require an Account Administrator.
  
  (c) We may establish policies and practices for the Platform, including deleting or
  removing Content, terminating inactive Accounts, or changing Services. Our Services
  may be changed, suspended, or discontinued at any time.
  
  (d) You are responsible for your Account's security. Notify us of any unauthorized
  use promptly. We are not liable for third-party access resulting from your failure
  to comply with these Terms.
  
  **Subscription; Payment Terms**
  
  (a) We offer various Subscription Levels with associated Subscription Fees. Fees
  are subject to change, impacting renewals but not current Subscription Terms.
  
  (b) You agree to pay Subscription Fees associated with your Subscription. Payment
   terms are as stated on our Platform or Order.
  
  (c) We may collect payments through third-party processors. By providing payment
  information, you authorize us to charge your payment method for Fees. Failure to
  verify or accept your payment method may result in suspension or cancellation.
  
  (d) Subscription Fees may consist of recurring charges. By choosing a recurring
  payment plan, you acknowledge and accept responsibility for all recurring charges.
  
  (e) We may submit periodic charges without further authorization until notice of
  termination or payment method change is provided. Charges submitted before notice will
  not be affected.
  
  (f) Your subscription will automatically renew unless terminated before the end of
  the then-current Subscription Term. Termination may occur through Account settings.
  No refunds are provided for early termination.
  
  Certainly! Here's the rewritten version:
  
  ---
  
  **UMYO Police   App Terms of Service**
  
  **1. Account Information and Updates**
  
  (g) You must provide accurate, current, and complete information for your UMYO Police  
  account. Ensure timely updates for your billing account, including changes to
  billing address, credit card number, or expiration date. Promptly notify us or
  our payment processor about canceled payment methods or potential security breaches.
  Make changes through your account settings. Failure to provide accurate information
  authorizes us to continue charging subscription fees.
  
  **2. Free Trials and Subscriptions**
  
  (h) Free trials for paid subscription levels are offered with specific terms disclosed
   during the offer. Trials are for users without prior paid subscriptions. Obtaining a
  free tier allows one account creation. Non-genuine use may result in standard fees or
   service denial. Acceptance of free trial subscription implies agreement to associated
    fees upon expiration unless canceled.
  
  **3. User-Generated Content**
  
  (a) Users can post content ("Content") on UMYO Police  . Posted Content is not confidential,
   treated as public information. By posting, users represent having the right to do so
  and grant us a non-exclusive license to use it for platform operation and promotion.
  
  (b) Users warrant that Content doesn't infringe third-party rights. We reserve the
   right to review and may refuse or remove Content violating terms, policies, or
  laws. Prohibited actions include unlawful, harmful, or objectionable Content;
  collecting personal information without consent; creating derivative works; and
  interfering with platform operations.
  
  (c) The platform may contain links to third-party services ("Third Party
  Services"). These services are not covered by our terms, and we are not
  responsible for them.
  
  (d) Platform content is protected by intellectual property laws. All related
  rights are exclusively ours. Users providing feedback grant us rights to use it freely.
  
  **4. Limitation on Liability**
  
  (a) We're not liable for user-posted Content, user interactions, losses from platform
  use, negative comments, or third-party information provided without consent. Users are
  responsible for interactions with others; we may not intervene in disputes.
  
  (b) We're not liable for indirect, incidental, or exemplary damages arising from a
   breach of terms, regardless of foreseeability. Our aggregate liability is limited
  to the total amounts paid by you in the previous 12 months.
  
  **5. Indemnification**
  
  Users indemnify us against any losses arising from claims by third parties related to
  platform use, purchased products or services, or user negligence or breach of terms.
  
  **6. Governing Law**
  
  These terms are governed by the laws of the State of Alabama.
  
  **7. Binding Arbitration**
  
  (a) By accepting these terms, you waive the right to a jury trial and class action
  participation. Disputes are resolved through binding arbitration. Some claims are
  exempted, including those regarding intellectual property rights or small claims.
  
  (b) Disputes must be addressed informally for at least 30 days before arbitration.
  If unresolved, either party may elect binding arbitration administered by the
  American Arbitration Association in Birmingham, Alabama.
  
  **8. General**
  
  (a) Unenforceability of one provision won't affect others. In case of conflict,
  we decide which provision prevails. Headings are for convenience. Our
  non-enforcement doesn't waive future enforcement rights.
  
  (b) Products and services may be subject to US export control laws. Users
   are responsible for compliance. Communication with us is electronic,
   fulfilling legal requirements.
  
  (c) Notices are provided within the platform or through services. Users
    can notify us via mail.
  
  (d) "Include" or "including" is not limiting, and "or" means "and/or."
  
  ---
  
            </pre
          >
        </div>
      </div>
    </div>
  </div>
</div>
